import {createAction, props} from '@ngrx/store';

export const UNSUBSCRIBE = '[Blog Page] Blog';
export const UNSUBSCRIBE_SUCCESS = '[Blog Page] Blog Success';
export const UNSUBSCRIBE_FAILURE = '[Blog Page] Blog Failure';

export const unsubscribe = createAction(
  UNSUBSCRIBE,
  props<{ resource: string }>()
)

export const unsubscribeSuccess = createAction(
  UNSUBSCRIBE_SUCCESS
)

export const unsubscribeFailure = createAction(
  UNSUBSCRIBE_FAILURE,
  props<{ error: string }>()
)
